import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';

@Component({
  selector: 'app-_126_ServicesDeliveredDetailSELPA',
  templateUrl: './_126_ServicesDeliveredDetailSELPA.component.html',
  styleUrls: ['./_126_ServicesDeliveredDetailSELPA.component.css']
})
export class _126_ServicesDeliveredDetailSELPAComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date;
  selectedPAU: SelectItem; selectedSite: SelectItem; selectedStudent: SelectItem;
  _PAUid: string = null; _siteId: string = null; _studentId: string = null; _selectedSchoolYear: string = null;
  public showSpinner: boolean = false;
  fromDate: Date;
  toDate: Date;
  minDate: Date;
  maxDate: Date;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupStudentList: ILookupBase[] = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
    this.date = new Date();
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.fromDate = new Date('03/01/2023');
    this.toDate = new Date('04/28/2023');

    this.minDate = new Date('01/01/2021');
    this.maxDate = new Date();
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {

    this.lookupStudentList = [
      { value: null, label: "-- Select a Student --", shortText: null, updatedOn: null },
      { value: "ARAGJA021605M001", label: "Juan Aragon", shortText: null, updatedOn: null },
      { value: "ALLEKM112207M001", label: "Kenneth Allen", shortText: null, updatedOn: null },
      { value: "BURGM111805M001", label: "MALACHAI BURGOS", shortText: null, updatedOn: null },
      { value: "CHOATN090505M001", label: "TYLER CHOATE", shortText: null, updatedOn: null },
      { value: "CASTV051806M001", label: "VICTOR CASTILLO", shortText: null, updatedOn: null },
      { value: "EPITFD111604M001", label: "FERNANDO EPITACIO", shortText: null, updatedOn: null },
      { value: "ESTEIS090605F001", label: "Iris Estes", shortText: null, updatedOn: null },
      { value: "FLORA 031505F001", label: "Angie Flores", shortText: null, updatedOn: null },
      { value: "FLORNL061805M001", label: "NATHAN FLORES", shortText: null, updatedOn: null },
      { value: "GAREMA052906M001", label: "Mateo Gareza", shortText: null, updatedOn: null },
      { value: "GONZZY090807F001", label: "Ziany Gonzaga", shortText: null, updatedOn: null },
      { value: "KIDDE 062207M001", label: "Ezekiel Kidder", shortText: null, updatedOn: null },
      { value: "KNOLMJ031006F001", label: "Maylinda Knoles", shortText: null, updatedOn: null },
      { value: "MILLBM071205F001", label: "Brigid Miller", shortText: null, updatedOn: null },
      { value: "MERCJI112507M001", label: "JACOB MERCADO", shortText: null, updatedOn: null },
      { value: "MARTTI111006M001", label: "Teodoro Martinez Gonzalez", shortText: null, updatedOn: null },
      { value: "NAM HG110606F001", label: "Hana Nam", shortText: null, updatedOn: null },
      { value: "PRESTM060205M001", label: "Tyree Presley", shortText: null, updatedOn: null },
      { value: "RAMOJJ100807M001", label: "JONATHAN RAMOS", shortText: null, updatedOn: null },
      { value: "SALAAA083005M001", label: "ANDRES SALAZAR ORTIZ", shortText: null, updatedOn: null },
      { value: "SHEAHA060306M001", label: "Hatcher Shea", shortText: null, updatedOn: null },
      { value: "TERRJ 111505M001", label: "Joel Terrazas", shortText: null, updatedOn: null },
      { value: "LANDTM092406M001", label: "Landon Theil", shortText: null, updatedOn: null },
      { value: "VALEJC082204M001", label: "Johnny Valencia", shortText: null, updatedOn: null },
      { value: "WOLFJA071405F001", label: "Jade Wolf", shortText: null, updatedOn: null }];
  }


  setStudent(id): void {
    this._studentId = id.value;
  }

  getSelectedDateData() {
    this.LoadLookupValues();
  }

  getstudentId(): string {
    let studentId: string;

    if (this.selectedStudent.value == null) {
      studentId = '';
    }
    else {
      studentId = this.selectedStudent.value;
    }
    return studentId;
  }

  viewReport() {
    var selectedStudentValue = this.lookupStudentList.find(z => z.value === this._studentId).label;

    let reportParamArray: IReportParameter[] = [];
    reportParamArray.push(
      { parameterName: 'LocalStudentId', parameterValue: this._studentId },
      { parameterName: 'SelectedStudent', parameterValue: selectedStudentValue },
      { parameterName: 'FromDate', parameterValue: this.fromDate.toISOString() },
      { parameterName: 'ToDate', parameterValue: this.toDate.toISOString() }
    );

    let now = new Date();
    let localReportFileName = '126-ServicesDeliveredDetailSELPA_' + now.toLocaleDateString() + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = 'SpedXReports';
    reportRequest.reportFileName = "IEP_SpecialEd_ServicesDeliveredDetailSELPA";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
